import React from 'react';

export interface ThirdPartyContentBlockProps {
	scriptUrlValue?: string;
	scriptValue?: string;
	cssUrlValue?: string;
	cssValue?: string;
	htmlValue?: string;
	hideOnMobile?: boolean;
}

export function ThirdPartyBlock(props: ThirdPartyContentBlockProps) {
	const { scriptUrlValue, scriptValue, htmlValue, cssValue, cssUrlValue } = props;
	const injectRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		const head = document.head || document.getElementsByTagName('head')[0];
		const appendedNodes: HTMLElement[] = [];
		let linkElem: HTMLLinkElement | null = null;
		let linkAppended = false;

		if (scriptUrlValue && injectRef.current) {
			const scriptSrc = document.createElement('script');
			scriptSrc.defer = true;
			scriptSrc.src = scriptUrlValue;
			injectRef.current.appendChild(scriptSrc);
			appendedNodes.push(scriptSrc);
		}

		if (scriptValue && injectRef.current) {
			const scriptCode = document.createElement('script');
			scriptCode.defer = true;
			scriptCode.text = scriptValue;
			injectRef.current.appendChild(scriptCode);
			appendedNodes.push(scriptCode);
		}

		if (cssUrlValue && head) {
			linkElem = document.createElement('link');
			linkElem.rel = 'stylesheet';
			linkElem.href = cssUrlValue;
			head.appendChild(linkElem);
			linkAppended = true;
		}

		return () => {
			// Remove scripts/styles previously appended
			appendedNodes.forEach((node) => {
				if (node.parentNode) node.parentNode.removeChild(node);
			});

			if (linkAppended && linkElem && head.contains(linkElem)) {
				head.removeChild(linkElem);
			}
		};
	}, [scriptUrlValue, scriptValue, cssUrlValue]);

	return (
		<>
			{cssValue && <div dangerouslySetInnerHTML={{ __html: <style>{cssValue}</style> }} />}
			{htmlValue && <div dangerouslySetInnerHTML={{ __html: htmlValue }} />}
			<div ref={injectRef} />
		</>
	);
}
